import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-header-banner',
  templateUrl: './boma-header-banner.component.html',
  styleUrls: ['./boma-header-banner.component.scss'],
})
export class BomaHeaderBannerComponent implements OnInit {
  @Input() Title = 'Trade Your Way';
  @Input() SubTitle = 'Download the Boma app and start today';
  @Input() Type = 'trader';
  @Input() showButtons = true;
  @Input() buttons = ['playstore'];
  @Input() backgroundPosition;

  readonly PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=today.boma.app';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    this.redirectToPlayStoreIfAndroid();
  }

  private redirectToPlayStoreIfAndroid(): void {
    const userAgent = this.document.defaultView?.navigator.userAgent;
    if (userAgent && /android/i.test(userAgent)) {
      window.location.href = this.PLAY_STORE_URL;
    }
  }
}
